'use strict';

// custom click handler to not prevent default
// on touch devices if href is defined
app.directive('rmClick', function () {
  return {
    scope: { action: '&rmClick' },
    link: function (scope, element) {
      element.on('click', function () {
        scope.$apply(scope.action);
      });
    }
  };
});
